import React from 'react';

import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import PrintBarcodeModal from 'label-printing/PrintBarcodeModal';
import Tooltip from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import runModal from 'ui-library/runModal';

export interface PrintLabelIconProps {
  itemIds: Array<string>;
}

/**
 * A print icon that opens the "Print Label" modal on click.
 */
class PrintLabelIcon extends React.Component<PrintLabelIconProps> {
  private handleOpenPrintBarcodeModal = (): void => {
    runModal(PrintBarcodeModal, {itemIds: this.props.itemIds});
  };

  override render(): JSX.Element | null {
    if (!isFeatureEnabled({feature: InventoryFeature.INVENTORY_EXPORT})) {
      return null;
    }
    return (
      <Tooltip title="Print...">
        <BenchlingIcon
          className="u-mini-spacing-left u-pointer"
          icon="format-print"
          onClick={this.handleOpenPrintBarcodeModal}
        />
      </Tooltip>
    );
  }
}

export default PrintLabelIcon;
